import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "unon",
  "use": "unon-usage",
  "viewBox": "0 0 15.59 20.64",
  "content": "<symbol viewBox=\"0 0 15.59 20.64\" id=\"unon\"><title>资源 13</title><g id=\"unon_图层_2\" data-name=\"图层 2\"><g id=\"unon_图层_1-2\" data-name=\"图层 1\"><path d=\"M13.24,15.79h-1.5v-1a.47.47,0,0,1,.22-.39A7.79,7.79,0,0,0,7.8,0H7.58A7.79,7.79,0,0,0,3.64,14.38a.47.47,0,0,1,.22.39v1H2.36a.88.88,0,1,0,0,1.76H13.24a.88.88,0,1,0,0-1.76Z\" /><path d=\"M11.88,18.88H3.72a.88.88,0,1,0,0,1.76h8.16a.88.88,0,0,0,0-1.76Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/unon.svg
// module id = P/W0
// module chunks = 264